import { AuditResult } from '../types';
import { getFirebaseFunctionUrl } from './firebase';

export const analyzeDomain = async (domain: string, customDkimSelector?: string): Promise<AuditResult> => {
  const url = getFirebaseFunctionUrl('analyzeDomain');

  const selectors: string[] = [];
  if (customDkimSelector) {
    selectors.push(customDkimSelector);
  }

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        domain,
        customDkimSelector: selectors,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Function returned an error: ${response.status} ${errorText}`);
    }

    const data = await response.json();
    return data as AuditResult;
  } catch (error) {
    console.error('Error calling analyzeDomain function:', error);
    throw error;
  }
};